import React from 'react';

export default function QuizResultModal({ result, onClose }) {
  if (!result) return null;
  
  const isPassed = parseFloat(result.score || 0) >= 80;
  
  return (
    <div 
      className="tw:fixed tw:inset-0 tw:z-[9999] tw:flex tw:items-center tw:justify-center tw:p-4 tw:bg-gray-900/60 tw:backdrop-blur-sm tw:transition-opacity"
      onClick={onClose}
    >
      <div 
        className="tw:bg-white tw:rounded-2xl tw:shadow-2xl tw:max-w-sm tw:w-full tw:overflow-hidden tw:transform tw:transition-all tw:scale-100 tw:relative"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button 
          onClick={onClose}
          className="tw:absolute tw:top-4 tw:right-4 tw:z-10 tw:p-2 tw:rounded-full tw:bg-black/20 hover:tw:bg-black/30 tw:text-white tw:transition-colors"
        >
          <svg className="tw:w-5 tw:h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        {/* Header with Icon */}
        <div className={`tw:h-32 ${isPassed ? 'tw:bg-green-500' : 'tw:bg-red-500'} tw:relative tw:flex tw:items-center tw:justify-center tw:overflow-hidden`}>
          <div className="tw:absolute tw:inset-0 tw:bg-white/10" style={{ backgroundImage: 'radial-gradient(circle, #ffffff33 1px, transparent 1px)', backgroundSize: '10px 10px' }}></div>
          <div className={`tw:w-20 tw:h-20 tw:rounded-full tw:bg-white/20 tw:backdrop-blur-md tw:flex tw:items-center tw:justify-center tw:shadow-inner`}>
            {isPassed ? (
              <svg className="tw:w-10 tw:h-10 tw:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
              </svg>
            ) : (
              <svg className="tw:w-10 tw:h-10 tw:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M6 18L18 6M6 6l12 12" />
              </svg>
            )}
          </div>
        </div>

        {/* Content */}
        <div className="tw:p-8 tw:text-center">
          <h2 className={`tw:text-2xl tw:font-bold tw:mb-2 ${isPassed ? 'tw:text-green-600' : 'tw:text-red-600'}`}>
            {isPassed ? 'Congratulazioni!' : 'Non superato'}
          </h2>
          
          <p className="tw:text-gray-500 tw:text-sm tw:mb-8 tw:leading-relaxed">
            {isPassed 
              ? 'Hai completato il quiz con successo. Ottimo lavoro!' 
              : 'Non hai raggiunto il punteggio minimo dell\'80%. Riprova per sbloccare il certificato.'}
          </p>

          {/* Score Card */}
          <div className="tw:bg-gray-50 tw:rounded-xl tw:p-6 tw:mb-8 tw:border tw:border-gray-100">
            <div className="tw:flex tw:items-center tw:justify-center tw:gap-1">
              <span className={`tw:text-5xl tw:font-black ${isPassed ? 'tw:text-green-600' : 'tw:text-red-500'}`}>
                {Math.round(result.score)}
              </span>
              <span className="tw:text-2xl tw:font-bold tw:text-gray-400 tw:mt-3">%</span>
            </div>
            <div className="tw:text-xs tw:font-medium tw:text-gray-400 tw:uppercase tw:tracking-wider tw:mt-2">
              Punteggio Totale
            </div>
            <div className="tw:mt-4 tw:flex tw:justify-center tw:gap-4 tw:text-sm tw:text-gray-600">
              <div className="tw:flex tw:items-center tw:gap-1">
                <span className="tw:w-2 tw:h-2 tw:rounded-full tw:bg-green-500"></span>
                <span>{result.correct} Corrette</span>
              </div>
              <div className="tw:flex tw:items-center tw:gap-1">
                <span className="tw:w-2 tw:h-2 tw:rounded-full tw:bg-gray-300"></span>
                <span>{result.total} Totali</span>
              </div>
            </div>
          </div>

          {/* Action Button */}
          <button
            onClick={onClose}
            className={`tw:w-full tw:py-3.5 tw:px-6 tw:rounded-xl tw:font-bold tw:text-white tw:shadow-lg tw:transform tw:transition-all hover:tw:scale-[1.02] active:tw:scale-[0.98] ${
              isPassed 
                ? 'tw:bg-green-600 hover:tw:bg-green-700 tw:shadow-green-200' 
                : 'tw:bg-gray-800 hover:tw:bg-gray-900 tw:shadow-gray-200'
            }`}
          >
            {isPassed ? 'Continua' : 'Chiudi e Riprova'}
          </button>
        </div>
      </div>
    </div>
  );
}
